export default __webpack_public_path__ + "static/media/dragonborn.a41dc230.jpeg";